import subjectResolverUtil from '../utils/subject-resolver-util'
const UNSET_KEYS = ['componentTypes', 'tags', 'standardSets', 'standardStrands']
/**
 *
 * @param metadata - the metadata for an existing CS resource
 *
 */
let createMetadataObject = (metadata, filters, initResource) => {
  let types = null
  let grades = null
  let updates = null
  let subjects = null
  if (metadata.types) {
    types = resolvefilterIds(metadata.types, filters.contentTypes)
  }
  if (metadata.grades) {
    grades = metadataGradeObj(resolvefilterIds(metadata.grades, filters.grades))
  }
  if (metadata.subjects) {
    subjects = resolveSubjectFilterIds(metadata.subjects, filters.subjects)
  }
  if (!initResource) {
    updates = metadataBuilder()
      .set('tags', metadata.keywords)
      .set('author', metadata.author)
      .set('componentTypes', types)
      .set('description', metadata.description)
      .set('title', metadata.title)
      .set('subjects', subjects)
      .set('expiry', metadata.expiry)
      .set('country', metadata.country)
      .set('language', metadata.language)
      .set('grades', grades)
      .set('standardSets', metadata.standard)
      .set('standardStrands', metadata.strands)
      .build()
  } else {
    updates = initResourceMetadataBuilder()
      .set('tags', metadata.keywords)
      .set('author', metadata.author)
      .set('componentTypes', types)
      .set('description', metadata.description)
      .set('title', metadata.title)
      .set('subjects', subjects)
      .set('expiry', metadata.expiry)
      .set('country', metadata.country)
      .set('language', metadata.language)
      .set('grades', grades)
      .set('standardSets', metadata.standard)
      .set('standardStrands', metadata.strands)
      .build()
  }

  return updates
}

let metadataBuilder = () => {
  let data = {}
  let builder = {
    set: (key, value, op) => {
      if (value) {
        data[key] = {
          data: value,
          op: op || 'SET'
        }
      }
      return builder
    },
    build: () => {
      for (const key in data) {
        let value = data[key]
        if (value.data.length === 0 && UNSET_KEYS.includes(key)) {
          data[key].op = 'UNSET'
        }
      }
      return data
    }
  }

  return builder
}

let initResourceMetadataBuilder = () => {
  let data = {}
  let builder = {
    set: (key, value) => {
      if (value) {
        data[key] = value
      }
      return builder
    },
    build: () => {
      for (const key in data) {
        let value = data[key]
        if (value.length === 0 && UNSET_KEYS.includes(key)) {
          delete data[key]
        }
      }
      return data
    }
  }
  return builder
}

let metadataGradeObj = grades => {
  return [
    {
      levels: grades,
      locale: 'EN_US'
    }
  ]
}

let resolvefilterIds = (inputs, filters) => {
  if (inputs) {
    let matchedFilters = filters.filter(input => {
      return inputs.includes(input.title)
    })
    return matchedFilters.map(element => {
      return element.id
    })
  }
  return {}
}

let resolveSubjectFilterIds = (inputs, filters) => {
  if (inputs) {
    let matchedFilters = filters.filter(input => {
      return inputs.includes(input.title)
    })
    return matchedFilters.map(element => {
      return subjectResolverUtil.resolveSubjectIdForUpload(element.id)
    })
  }
  return {}
}

export default {
  createMetadataObject,
  resolvefilterIds,
  metadataBuilder
}
